import { DESTINATION_TYPE } from "@/server/types/export";
import { DEST_TYPE_LABELS, DESTINATION_LOGOS } from "@/frontend/types/dashboard/settings/activity";

export function getDestinationLogo(dest: any): string {
  if (dest.destination_type === DESTINATION_TYPE.FHIR_SERVER) return DESTINATION_LOGOS[DESTINATION_TYPE.FHIR_SERVER] ?? "/assets/fhir.png";
  return DESTINATION_LOGOS[dest.cloud_vendor] ?? "/assets/aws.png";
}

export function getDestTypeLabel(run: any): string {
  if (run.destination_type === DESTINATION_TYPE.FHIR_SERVER) return DEST_TYPE_LABELS[DESTINATION_TYPE.FHIR_SERVER] ?? "FHIR Server";
  return DEST_TYPE_LABELS[run.cloud_vendor] ?? "Object Storage";
}
